import { BaseController } from './BaseController';

export default class MessageController extends BaseController {
  id = 'MessageController';

  init() {
    this.root = this.getRoot();
    this.messages = this.childNodes('message');

    this.messages.forEach((message) => {
      setTimeout(this.removeMessage, 5000, message);
      message
        .querySelectorAll('button')[0]
        .addEventListener('click', this.closeMessage);
    });
  }

  removeMessage = (message) => {
    message.remove();
  };

  closeMessage = (e) => {
    e.target.parentNode.remove();
  };
}
